"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _FormattedCurrency = _interopRequireDefault(require("I18n/components/FormattedCurrency"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIToggle = _interopRequireDefault(require("UIComponents/input/UIToggle"));

var _UIMediaObject = _interopRequireDefault(require("UIComponents/layout/UIMediaObject"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UIExpandableText = _interopRequireDefault(require("UIComponents/text/UIExpandableText"));

var PlanType = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/pricings/PlanType"));

var _currency = require("ecosystem-marketplace-core/utils/currency");

var _PLAN_TYPE_PRICING_I;

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    margin-top: ", ";\n    margin-bottom: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: ", ";\n  background-color: ", ";\n  background-image: linear-gradient(-303deg, ", ", ", ");\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n  color: ", ";\n  text-align: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    padding: ", " ", " 16px;\n    text-align: center;\n\n    + & {\n      padding-top: 0;\n    }\n\n    &:last-child {\n      padding-bottom: ", ";\n    }\n\n    &.app-detail__pricing__plan-features {\n      text-align: left;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-radius: 3px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  min-width: 320px;\n  width: 320px !important;\n  margin-left: ", "px;\n  margin-right: 12px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.detail.pricing.plan." + key;
};

var PLAN_TYPE_PRICING_I18N_KEYS = (_PLAN_TYPE_PRICING_I = {}, (0, _defineProperty2.default)(_PLAN_TYPE_PRICING_I, PlanType.FREE, 'free_jsx'), (0, _defineProperty2.default)(_PLAN_TYPE_PRICING_I, PlanType.MONTHLY, 'monthly_jsx'), (0, _defineProperty2.default)(_PLAN_TYPE_PRICING_I, PlanType.YEARLY, 'yearly_jsx'), (0, _defineProperty2.default)(_PLAN_TYPE_PRICING_I, PlanType.ONE_TIME, 'oneTime_jsx'), _PLAN_TYPE_PRICING_I);
var CARD_HEADER_PADDING = _sizes.CARD_PADDING_COMPACT;
var TRIAL_BADGE_TOP_MARGIN = CARD_HEADER_PADDING;
var TRIAL_BADGE_BOTTOM_MARGIN = "-" + (parseInt(CARD_HEADER_PADDING, 10) + parseInt(_sizes.BADGE_ROUNDED_HEIGHT, 10) / 2) + "px";
var CardWrapper = (0, _styledComponents.default)(_UICardWrapper.default).withConfig({
  displayName: "PricingPlanCard__CardWrapper",
  componentId: "ue4aq3-0"
})(_templateObject(), function (props) {
  return props.index === 0 ? 0 : 12;
});
var ExpandableText = (0, _styledComponents.default)(_UIExpandableText.default).withConfig({
  displayName: "PricingPlanCard__ExpandableText",
  componentId: "ue4aq3-1"
})(_templateObject2());
var CardSection = (0, _styledComponents.default)(_UICardSection.default).withConfig({
  displayName: "PricingPlanCard__CardSection",
  componentId: "ue4aq3-2"
})(_templateObject3(), _sizes.CARD_PADDING_COMPACT, _sizes.CARD_PADDING, _sizes.CARD_PADDING_COMPACT);

var CardHeader = _styledComponents.default.div.withConfig({
  displayName: "PricingPlanCard__CardHeader",
  componentId: "ue4aq3-3"
})(_templateObject4(), CARD_HEADER_PADDING, _colors.THUNDERDOME, _colors.THUNDERDOME, _colors.CALYPSO, _colors.OLAF);

var TrialBadge = (0, _styledComponents.default)(_UIBadge.default).withConfig({
  displayName: "PricingPlanCard__TrialBadge",
  componentId: "ue4aq3-4"
})(_templateObject5(), TRIAL_BADGE_TOP_MARGIN, TRIAL_BADGE_BOTTOM_MARGIN, _colors.KOALA, _colors.OBSIDIAN);

var Price = function Price(props) {
  var children = props.children;
  return _react.default.createElement("div", {
    className: "is--heading-1 display-inline-block m-bottom-0"
  }, children || _react.default.createElement(_FormattedCurrency.default, props));
};

var PricingPlanCard = function PricingPlanCard(_ref) {
  var onTrackInteraction = _ref.onTrackInteraction,
      plan = _ref.plan,
      cardIndex = _ref.cardIndex;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showCommitmentPricing = _useState2[0],
      setShowCommitmentPricing = _useState2[1];

  var planType = plan.get('planType');
  var cents = plan.get('cents');
  var commitmentCents = plan.get('commitmentCents');
  var extraCharges = plan.get('extraCharges');
  var features = plan.get('features');
  var freeTrialDays = plan.get('freeTrialDays');
  var tagline = plan.get('tagline');
  var renderedTagline = (0, _react.useMemo)(function () {
    if (!tagline) {
      return null;
    }

    return _react.default.createElement("p", {
      className: "m-bottom-0"
    }, tagline);
  }, [tagline]);
  var renderedFreeTrialBadge = (0, _react.useMemo)(function () {
    if (!freeTrialDays) {
      return null;
    }

    return _react.default.createElement(TrialBadge, null, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('freeTrialBadgeText'),
      options: {
        freeTrialDays: freeTrialDays
      }
    }));
  }, [freeTrialDays]);
  var renderedPrice = (0, _react.useMemo)(function () {
    if (planType === PlanType.FREE) {
      return _react.default.createElement(Price, null, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('pricing.free')
      }));
    }

    var pricingI18nKey = PLAN_TYPE_PRICING_I18N_KEYS[planType];
    var value;

    if (planType === PlanType.MONTHLY && showCommitmentPricing) {
      value = (0, _currency.formatCentsToDollars)(commitmentCents / 12);
    } else {
      value = (0, _currency.formatCentsToDollars)(cents);
    }

    return _react.default.createElement(_FormattedJSXMessage.default, {
      message: getI18nKey("pricing." + pricingI18nKey),
      options: {
        currencyCode: 'USD',
        simplifyCurrency: true,
        value: value
      },
      elements: {
        Price: Price,
        Small: _Small.default
      }
    });
  }, [planType, cents, commitmentCents, showCommitmentPricing]);
  var renderedCommitmentPricingToggle = (0, _react.useMemo)(function () {
    if (!(planType === PlanType.MONTHLY && commitmentCents)) {
      return null;
    }

    return _react.default.createElement(CardSection, null, _react.default.createElement(_UIFormLabel.default, {
      className: "p-right-0"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('commitmentPricingToggleLabels.monthly')
    })), _react.default.createElement(_UIToggle.default, {
      className: "m-x-3",
      onChange: function onChange(_ref2) {
        var checked = _ref2.target.checked;
        setShowCommitmentPricing(checked);
        onTrackInteraction('toggle plan commitment pricing', 'pricing', checked ? 'yearly' : 'monthly');
      },
      size: "extra-small",
      textChecked: "",
      textUnchecked: ""
    }), _react.default.createElement(_UIFormLabel.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('commitmentPricingToggleLabels.yearly')
    })));
  }, [planType, commitmentCents, onTrackInteraction]);
  var renderedExtraCharges = (0, _react.useMemo)(function () {
    if (!extraCharges) {
      return null;
    }

    return _react.default.createElement(CardSection, null, _react.default.createElement(_Small.default, {
      use: "help"
    }, extraCharges));
  }, [extraCharges]);
  var renderedFeatures = (0, _react.useMemo)(function () {
    if (!features) {
      return null;
    }

    var splitFeatures = features.split(/\r?\n/g);
    return _react.default.createElement(CardSection, {
      className: "app-detail__pricing__plan-features"
    }, _react.default.createElement(_UIList.default, {
      childClassName: "m-bottom-2"
    }, splitFeatures.map(function (feature, index) {
      return _react.default.createElement(_UIMediaObject.default, {
        key: "feature-" + index,
        align: "start",
        itemLeft: _react.default.createElement(_UIIcon.default, {
          name: "success",
          color: _colors.OZ
        })
      }, feature);
    })));
  }, [features]);
  return _react.default.createElement(CardWrapper, {
    index: cardIndex
  }, _react.default.createElement(ExpandableText, {
    maxHeight: 410,
    expandOnFocus: false
  }, _react.default.createElement(CardHeader, null, _react.default.createElement("div", {
    className: (0, _classnames.default)('is--heading-3', {
      'm-bottom-0': !renderedTagline
    })
  }, plan.get('name')), renderedTagline, renderedFreeTrialBadge), _react.default.createElement(CardSection, null, renderedPrice), renderedCommitmentPricingToggle, renderedExtraCharges, renderedFeatures));
};

PricingPlanCard.propTypes = {
  onTrackInteraction: _propTypes.default.func.isRequired,
  plan: CustomPropTypes.pricingPlan.isRequired,
  cardIndex: _propTypes.default.number
};
var _default = PricingPlanCard;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/pricing/PricingPlanCard.js
// module id = 841
// module chunks = 209 210 211 212